import React, { Component } from "react";
import readXlsxFile, { parseExcelDate } from "read-excel-file";
// import { MDBDataTableV5 } from "mdbreact";
import {
  Button,
  Upload,
  Radio,
  Table,
  Checkbox,
  Switch,
  message,
  Input,
} from "antd";
import {
  InboxOutlined,
  FileExcelOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { IoText } from "react-icons/io5";
import { TiSortNumerically } from "react-icons/ti";
import { FcOvertime } from "react-icons/fc";
import { FaPercentage } from "react-icons/fa";
// import CodeEditor from "@uiw/react-textarea-code-editor";
import callBack from "../../callback";
import { isNumber, isString } from "lodash";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
const _ = require("lodash");
const { Dragger } = Upload;
const host = "https://xlsx.viabber.com";
dayjs.extend(customParseFormat);

// const host = "https://vaibber-excel-api.herokuapp.com";
// const host = "http://localhost:5001";

export default class Excel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      json: [],
      data: [],
      rows: [],
      url: "",
      col: [
        {
          title: "Colonne",
          width: 100,
          dataIndex: "name",
          key: "name",
          fixed: "left",
        },
        // {
        //   title: "Type de colonne",
        //   width: 100,
        //   render: (e) => {
        //     return (
        //       <Radio.Group
        //         options={[
        //           {value: "indicator", label: "Indicateur"},
        //           {value: "dimension", label: "Dimension"},
        //         ]}
        //         onChange={(value)=>this.setColumnType(value, e)}
        //         size="small"
        //         value={this.state.rows[e.index].columnType}
        //         defaultValue={e.columnType}
        //         optionType="button"
        //         buttonStyle="solid"
        //       />
        //     );
        //   },
        // },
        {
          title: "Indicateur",
          width: 100,
          render: (e) => {
            return (
              <Switch
                // options={[
                //   {value: "indicator", label: "Indicateur"},
                //   {value: "dimension", label: "Dimension"},
                // ]}
                onChange={(value) => this.setColumnType(value, e)}
                // size="small"
                checked={this.state.rows[e.index].columnType == "indicator"}
                // defaultValue={e.columnType}
                optionType="button"
                buttonStyle="solid"
              />
            );
          },
        },
        {
          title: "Type",
          width: 200,
          render: (e) => {
            // Fait - TODO
            return (
              <Radio.Group
                options={[
                  { value: 1, label: <TiSortNumerically /> },
                  { value: 2, label: <IoText /> },
                  { value: 3, label: <FcOvertime /> },
                  { value: 4, label: <FaPercentage /> },
                ]}
                onChange={(value) => this.setDataType(value, e)}
                // size="small"
                value={this.state.rows[e.index].dataType}
                defaultValue={e.dataType}
                optionType="button"
                buttonStyle="solid"
              />
            );
          },
        },
        {
          title: "Ignorer",
          key: "ignored",
          // fixed: "right",
          width: 100,
          render: (e) => (
            <Checkbox
              onChange={(value) => this.setCheck(value, e)}
              defaultChecked={e.ignored}
              checked={this.state.rows[e.index].ignored}
            />
          ),
        },
      ],
    };
  }

  setCheck = (value, e) => {
    // console.log("value :>> ", value);
    this.state.rows[e.index].ignored = value.target.checked;
    this.setState({
      rows: [...this.state.rows],
    });
  };

  setDataType = (value, e) => {
    this.state.rows[e.index].dataType = value.target.value;
    if (value.target.value != 1 && value.target.value != 4) {
      this.state.rows[e.index].columnType = "dimension";
    }
    this.setState({
      rows: [...this.state.rows],
    });
  };

  setColumnType = (value, e) => {
    // this.state.rows[e.index].columnType = value.target.value
    if (
      this.state.rows[e.index].dataType == 1 ||
      this.state.rows[e.index].dataType == 4
    ) {
      this.state.rows[e.index].columnType =
        this.state.rows[e.index].columnType == "indicator"
          ? "dimension"
          : "indicator";
      this.setState({
        rows: [...this.state.rows],
      });
    } else {
      message.info("Un indicateur ne peut être qu'un nombre ou un pourcentage");
    }
  };

  normalizeDate = (excelDate) => {
    if (!excelDate) return null; // Gestion des valeurs nulles ou vides

    // 1️⃣ Vérifier si la date est un numéro de série Excel (nombre > 20000 pour éviter les années erronées)
    if (!isNaN(excelDate) && excelDate > 20000) {
      const excelEpoch = new Date(Date.UTC(1899, 11, 30)); // Base des dates Excel
      return new Date(excelEpoch.getTime() + excelDate * 86400000); // Convertir en timestamp
    }

    // 2️⃣ Si la date est une chaîne de caractères, essayer de la parser
    const formats = [
      "DD/MM/YYYY",
      "MM/DD/YYYY",
      "YYYY-MM-DD",
      "YYYY/MM/DD",
      "DD-MM-YYYY",
      "MM-DD-YYYY",
      "DD MMM YYYY",
      "MMM DD, YYYY",
    ];

    for (const format of formats) {
      const parsedDate = dayjs(excelDate, format, true);
      if (parsedDate.isValid()) {
        return new Date(
          parsedDate.year(),
          parsedDate.month(),
          parsedDate.date()
        );
      }
    }

    return null; // Date invalide
  };

  componentDidMount() {}
  // FAIT - TODO
  init = (rows) => {
    let data = [...rows];
    data.splice(0, 1);
    // console.log("data :>> ", data);
    let columns = [];

    for (let j = 0; j < rows[0].length; j++) {
      const column = rows[0][j];

      let isNumber = false;
      let isString = false;
      let isObject = false;
      let isPercent = false;
      let isDate = false;
      let value = rows[1][j];

      switch (typeof value) {
        case "number":
          isNumber = true;
          break;

        case "string":
          if (value.search("%") != -1) isPercent = true;
          else isString = true;
          break;

        case "object":
          isObject = true;
          try {
            value.getFullYear();
            isDate = true;
          } catch (e) {}
          break;
      }

      columns.push({
        index: j,
        name: column,
        columnType: isNumber || isPercent ? "indicator" : "dimension",
        dataType: isNumber
          ? 1
          : isDate
          ? 3
          : isString
          ? 2
          : isPercent
          ? 4
          : null,
        ignored: isObject && !isDate ? true : false,
      });
    }

    this.setState({ data, rows: columns, loading: false });
  };

  selectFile = (e) => {
    this.setState({ loading: true });
    readXlsxFile(e).then((rows) => {
      this.init(rows);
    });
  };

  genrateLink = async (columns, items) => {
    this.setState({ loading: true });
    if (this.state.url) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        columns,
        url: this.state.url.includes("https://docs.google.com")
          ? `https://drive.google.com/uc?export=download&id=${
              this.state.url.split("/")[5]
            }`
          : this.state.url,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${host}/data/link`, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((result) => {
          if (result) {
            callBack(
              {
                columns: columns,
                rows: items,
                url: result.url,
              },
              200
            );
            console.log("first", {
              columns: columns,
              rows: items,
              url: result.url,
            });
          }
        })
        .catch(() => {})
        .then(() => {
          this.setState({ loading: false });
        });
    }
  };

  // TODO
  onSubmit = () => {
    // console.log("this.state.rows :>> ", this.state.rows);
    let rows = [...this.state.rows];

    let columns = _.filter(rows, (o) => {
      return !o.ignored;
    });
    let indicators = _.filter(columns, (o) => {
      return o.columnType === "indicator";
    });

    if (columns.length) {
      if (indicators.length) {
        // console.log("columns :>> ", columns);
        // console.log("indicators :>> ", indicators);
        let items = [];
        for (let index = 0; index < this.state.data.length; index++) {
          const row = this.state.data[index];
          let item = [];
          for (let j = 0; j < columns.length; j++) {
            const element = columns[j];
            // TODO int & date & %: parseInt

            if (element.dataType === 4) {
              if (
                typeof row[element.index] === "number" ||
                row[element.index] instanceof Number
              ) {
                item.push(100 * row[element.index]);
              } else if (
                typeof row[element.index] === "string" ||
                row[element.index] instanceof String
              ) {
                item.push(parseFloat(row[element.index]));
              }
            } else if (element.dataType === 1) {
              item.push(parseFloat(row[element.index]));
            } else if (+element.dataType === 3) {
              let date = new Date(row[element.index]);
              if (isNaN(date.getTime())) {
                date = this.normalizeDate(row[element.index]);
              }

              item.push(date);
            } else {
              item.push(row[element.index]);
            }
          }
          items.push(item);
        }
        let col = [];
        for (let index = 0; index < columns.length; index++) {
          const element = columns[index];
          col.push({
            index: index,
            columnType: element.columnType,
            dataType: element.dataType,
            name: element.name,
          });
        }
        console.log("json :>> ", {
          columns: col,
          rows: items,
        });

        if (!this.state.url) {
          callBack(
            {
              columns: col,
              rows: items,
            },
            200
          );
        } else {
          this.genrateLink(col, items);
        }
      } else {
        message.error("Aucun indicateur");
      }
    } else {
      message.error("Aucune colonne");
    }
  };

  onDownload = () => {
    this.setState({ loading: true });
    if (this.state.url) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        // url: "https://drive.google.com/uc?export=download&id=1GB9wIeXFprxoUymsNgrXmRJn3laLyMd6",
        url: this.state.url.includes("https://docs.google.com")
          ? `https://drive.google.com/uc?export=download&id=${
              this.state.url.split("/")[5]
            }`
          : this.state.url,
      });
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${host}/data/getData`, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            message.error(
              "Une erreur c'est produite vérifier le lien du fichier .xlsx"
            );
          }
        })
        .then((result) => {
          if (result) {
            this.init(result);
            // console.log("result :>> ", result);
          }
        })
        .catch((error) => console.log("error", error))
        .then(() => {
          this.setState({ loading: false });
        });
    }
  };

  render() {
    return (
      <div className="container">
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Input
            placeholder="Entrer le lien vers le fichier"
            prefix={
              <LinkOutlined
                onClick={() => {
                  navigator.clipboard
                    .readText()
                    .then((text) => this.setState({ url: text }));
                }}
              />
            }
            value={this.state.url}
            onChange={(e) => {
              this.setState({ url: e.target.value });
            }}
          />
          <Button
            type="primary"
            loading={this.state.loading}
            disabled={this.state.loading || !this.state.url.trim()}
            onClick={() => {
              this.onDownload();
            }}
          >
            Download
          </Button>
        </div>
        <br />
        <br />
        <Dragger
          multiple={false}
          beforeUpload={(e) => {
            this.selectFile(e);
            return false;
          }}
          accept=".xlsx"
          disabled={this.state.loading}
          action={null}
        >
          <p className="ant-upload-drag-icon">
            <FileExcelOutlined />
          </p>
          <p className="ant-upload-text">
            Cliquer ou glisser deposer votre fichier excel ici.
          </p>
          <p className="ant-upload-hint">
            Attention seul les fichiers xlsx sont pris en charge.
          </p>
        </Dragger>

        <Table
          columns={this.state.col}
          dataSource={this.state.rows}
          scroll={{ x: 700 }}
          loading={this.state.loading}
          pagination={false}
        />
        <br />
        <Button
          type="primary"
          onClick={this.onSubmit}
          loading={this.state.loading}
          disabled={this.state.loading}
        >
          Extraire les données
        </Button>
        <div className="card-body">
          <div
            className="table"
            style={{ width: "100%", overflowX: "auto" }}
          ></div>
        </div>
      </div>
    );
  }
}
